module.exports = __webpack_public_path__ + "img/prize-01.c5fd3272.jpg";